import BaseReducer from "@common/redux/reducers/BaseReducer";

// Helpers
import {
  getCurrentDateTime,
  getDatePart,
  getTimePart,
} from "@common/components/helpers/datetime";

class AgeVerificationReducer extends BaseReducer {
  domain = "AgeVerification";
  type = "View";

  initialState = {
    idTypes: [],
    genders: [],
    idOther: false,
    date: getDatePart(getCurrentDateTime()),
    time: getTimePart(getCurrentDateTime()),
    hasId: null,
    idType: null,
    otherId: "",
    gender: null,
    dateOfBirth: "",
    under18: false,
    under18Confirm: false,
    confirmation: false,
    childrenInArea: null,
    requestedRemoveChild: null,
    reasonNotRemoveChild: "",
    customerDescription: "",
    hasGambled: null,
    hasHadStakeReturned: null,
    hasBeenRefusedEntry: null,
    comments: "",
    record: null,
    config: {
      hasChildrenInGamingArea: false,
      hasNoIdCustomerDescription: false,
    },
  };
}

const reducer = new AgeVerificationReducer();

export default reducer;
